import { nanoid } from 'nanoid'
import TextInput from "./TextInput.jsx"

function BreakLine() {
  return <br />
}


class MyRegExp extends RegExp {
  [Symbol.matchAll](str) {
    const result = RegExp.prototype[Symbol.matchAll].call(this, str);
    if (!result) {
      return null;
    }
    return Array.from(result);
  }
}

export default function CodeTrou(props) {
  function parse(text) {
    const components = text.split(/(\%\%.*?\%\%)/);
    console.log(components)
    // Gestion des retour à la ligne
    const new_comp = []
    components.map(elmt => {
      let tmp = elmt.split("\n")
      if (tmp.length > 1) {
        tmp.slice(0,-1).map(e => {
          new_comp.push(e)
          new_comp.push(<BreakLine />)
        })        
        new_comp.push(tmp[tmp.length-1])
      }
      else {
        new_comp.push(tmp[0])
      }
    })


    console.log(new_comp)
    for (let i = 0; i < new_comp.length; i++) {
      console.log(typeof new_comp[i])
      if (typeof new_comp[i] == "string") {
        let content = new_comp[i].match(/(\%\%.*?\%\%)/)
        if (content) {
          content = content[0]
          content = content.replace("%%",'')
          content = content.replace("%%",'')
          console.log("content")
          console.log(content)
          new_comp[i] = <TextInput sol={content}></TextInput>
        }
      }
    }
    return new_comp
  }

  const components = parse(props.children)
  return (<div className={props.className} >
    {components.map(elmt => elmt)}
  </div>)
}